export const WinCreditType = {
    Total: 'Total',
    Net: 'Net',
} as const;

export type WinCreditType = typeof WinCreditType[keyof typeof WinCreditType];
